import { adoraStart } from "@adora-so/adora-js";
import { logger } from "@octopusdeploy/logging";
import { repository } from "~/clientInstance";
import { isFeatureToggleEnabled } from "~/components/FeatureToggle/New/FeatureToggleContext";

const ADORA_ORG_ID = "a0281577-8375-42cd-b78e-8615c3d40206";

export class AdoraIntegration {
    private static instance: AdoraIntegration | undefined;

    public static async create(): Promise<AdoraIntegration | undefined> {
        if (this.instance) {
            return this.instance;
        }

        if (!isFeatureToggleEnabled("adora-integration")) {
            return undefined;
        }

        try {
            const userProperties = await repository.Adora.getUserProperties();

            adoraStart({
                orgId: ADORA_ORG_ID,
                uid: userProperties.UserId,
                properties: {
                    "Installation Id": userProperties.InstallationId,
                    "Is Trial": userProperties.IsTrial,
                    "License Id": userProperties.LicenseId,
                    "Host Environment": userProperties.HostEnvironment,
                    "License Hash": userProperties.LicenseSerialNumberHash,
                },
            });
            this.instance = new AdoraIntegration();
            logger.info("Adora integration initialized successfully");
            return this.instance;
        } catch (error) {
            logger.error(error, "Failed to initialize Adora integration");
            return undefined;
        }
    }

    clear() {
        AdoraIntegration.instance = undefined;
    }
}
